import { postWithFiles } from "./fetch-upload-api";

const uploadFiles = (id: string, data: any, files: any) =>
  postWithFiles(`/upload/${id}`, data, files);

export { uploadFiles };
